import React from 'react'
import { LPVention101Section } from '../../api/Types'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'

type Props = LPVention101Section

const LandingPageVention101: React.FunctionComponent<Props> = ({
  title,
  items,
  style,
  display,
}) => {
  if (!items) {
    return null
  }

  return (
    <LandingPageSectionWrapper cssNamespace='vention-101-section' style={style}>
      {title && <h2 className='vention-101-section-title'>{title}</h2>}
      <div className={`vention-101-items-container ${display ? 'display-compact' : ''}`}>
        <ol>
          {items.map((item, i) => (
            <React.Fragment key={i}>
              <li className={`vention-101-item item-${i + 1}`}>
                <div className='vention-101-item-wrapper'>
                  <div className='vention-101-item-title-row'>
                    <div className='vention-101-item-index'>{`0${i + 1}`}</div>
                    {item.title && <h3 className='vention-101-item-title'>{item.title}</h3>}
                  </div>
                  {item.subtitle && (
                    <div
                      className='vention-101-item-subtitle'
                      dangerouslySetInnerHTML={{ __html: item.subtitle }}
                    />
                  )}
                </div>
              </li>
              {i < items.length - 1 && <i className={`fal fa-long-arrow-right arrow-${i + 1}`}></i>}
            </React.Fragment>
          ))}
        </ol>
      </div>
    </LandingPageSectionWrapper>
  )
}

LandingPageVention101.defaultProps = {
  title: 'How it works',
  items: [
    {
      title: 'Design',
      subtitle: 'Define your requirements and design your equipment in MachineBuilder.',
    },
    {
      title: 'Automate',
      subtitle: 'Create and simulate your automation sequence in MachineLogic.',
    },
    {
      title: 'Order',
      subtitle: 'Easily review your bill of material and place your order for next day delivery.',
    },
    {
      title: 'Deploy',
      subtitle: 'Assemble your equipment using auto-generated assembly instructions.',
    },
  ],
} as Partial<Props>

export default LandingPageVention101
